import { FailureSeverity } from '../types/FailureSeverity';
import { ValidationFailure } from '../types/ValidationFailure';
import { ValidationResult } from '../types/ValidationResult';

type ValidationObjectRule<T> = (args: T) => boolean | string;
export type ValidationRulesObject<T> = {
  [key: string]: ValidationObjectRule<T>;
};

const defaultValidationFailureCreator = (errorMessage: string): ValidationFailure => ({
  code: '400',
  severity: FailureSeverity.Error,
  message: errorMessage,
});

type RulesObjectValidatorArgs<T> = {
  rules: ValidationRulesObject<T>;
  validationFailureCreator?: (errorMessage: string) => ValidationFailure;
};

export const rulesObjectValidator = <T>({
  rules,
  validationFailureCreator = defaultValidationFailureCreator,
}: RulesObjectValidatorArgs<T>) => {
  const validResult: ValidationResult = { isValid: true, failures: [] };

  const validate = (args: T): ValidationResult => {
    const results = Object.values(rules).map(isRuleMet => isRuleMet(args));

    if (results.every(result => typeof result === 'boolean' && result)) return validResult;

    return {
      isValid: false,
      failures: results
        .filter(result => typeof result === 'string')
        .map(result => validationFailureCreator(result as string)),
    };
  };

  return { validate };
};
